import { useEffect, useState } from 'react';
import { X } from 'lucide-react';
import { subscribe } from '../utils/notify';

// Renders notifications from utils/notify (bottom-right, auto-dismiss).
export default function Toaster() {
  const [toasts, setToasts] = useState([]);

  useEffect(() => subscribe((t) => {
    setToasts((ts) => [...ts.filter((x) => x.message !== t.message), t].slice(-4));
    setTimeout(() => setToasts((ts) => ts.filter((x) => x.id !== t.id)), 9000);
  }), []);

  if (!toasts.length) return null;
  return (
    <div className="fixed bottom-4 right-4 z-[100] flex w-96 max-w-[calc(100vw-2rem)] flex-col gap-2" role="status" aria-live="polite">
      {toasts.map((t) => (
        <div key={t.id}
          className={`flex items-start gap-2 rounded-lg border px-3 py-2.5 text-sm shadow-lg ${t.kind === 'error'
            ? 'border-red-300 bg-red-50 text-red-900 dark:border-red-900 dark:bg-red-950 dark:text-red-100'
            : 'border-border bg-background text-foreground'}`}>
          <div className="flex-1 break-words">{t.message}</div>
          <button aria-label="Dismiss" className="opacity-60 hover:opacity-100"
            onClick={() => setToasts((ts) => ts.filter((x) => x.id !== t.id))}>
            <X className="h-4 w-4" />
          </button>
        </div>
      ))}
    </div>
  );
}
